import { EnvironmentSchema, validateEnvironment } from './validate-environment'

export const environment: EnvironmentSchema = validateEnvironment(process.env)
